import { Directive, ElementRef, HostListener, Input } from '@angular/core';

import { UploadEventsService } from '../upload-events-service/upload-events-service';
import { ValidDataTypes } from '../uploaders.interfaces';

@Directive({
  selector: 'input[bmFileUpload]',
})
/**
 * Implements the required callback and methods of file uploading
 */
export class FileUploadDirective {
  @Input() public dataType!: ValidDataTypes;

  constructor(
    private _elementRef: ElementRef<HTMLInputElement>,
    private _uploadEventsService: UploadEventsService,
  ) {}

  @HostListener('change', ['$event'])
  public onInputChange(e: Event) {
    e.preventDefault();
    const next =
      this._elementRef.nativeElement.files &&
      this._elementRef.nativeElement.files.length
        ? this._elementRef.nativeElement.files
        : null;

    this._uploadEventsService.readFiles(next, this.dataType);
  }
}
